
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import MatchCard from "../common/MatchCard";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";
import { ITournamentEditionMatch } from "../../../../../services";

export interface LatestMatchesProps {
    basePath: string;
    publicId: string;
    matches: ITournamentEditionMatch[];
}

function LatestMatches({ basePath, publicId, matches }: LatestMatchesProps) {

    const labels = i18nManager.Labels.home;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);

    if (!matches.length) return null;

    return (<section className={styles["section"]}>
        <div className={styles["container"]}>
            <SectionHeader kicker={labels.matches_kicker} title={labels.matches_title} titleEm={labels.matches_title_em}
                action={<ReactRouterDom.NavLink end className={styles["link-more"]} to={{ pathname: pagePath(basePath, "SCHEDULE"), search: searchParams.toString() }}>{labels.full_schedule}</ReactRouterDom.NavLink>} />
            <div className={styles["news-grid"]}>
                {matches.slice(0, 5).map((m) => (<MatchCard key={m.external_id} publicId={publicId} match={m} />))}
            </div>
        </div>
    </section>);
}

export default LatestMatches;
